import React, {useCallback, useMemo} from 'react';
import {Link} from 'react-router-dom';


import {ACCOUNT_TABS} from 'src/constants';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

type Props = {
    accountId: number,
    accountName: string,
    blank?: boolean,
    place: string,
    target?: string,
};

export const AccountLink: React.FC<Props> = ({
    accountId,
    accountName,
    blank,
    place,
    target,
}) => {
    const {hasAccess} = useAdminAccessRight();
    const linkIsAvailable = useMemo(() => hasAccess(ACCESS_RIGHTS.ACCOUNT_SCREEN_VIEW), [hasAccess]);

    if (linkIsAvailable) {
        return (
            <LinkView
                accountId={accountId}
                accountName={accountName}
                place={place}
                target={target}
                blank={blank}
            />
        );
    }

    return (
        <EllipsisTextHint title={accountName}>
            {accountName}
        </EllipsisTextHint>
    );
};

type LinkViewProps = {
    accountId: number,
    accountName: string,
    place: string,
    blank?: boolean,
    target?: string,
};

const LinkView = ({place, accountId, target, blank, accountName}: LinkViewProps) => {
    const {accountProfileOpen} = useEventTracking();
    const onTrackAccountProfileOpen = useCallback(() => {
        if (place) {
            accountProfileOpen({place});
        }
    }, [place, accountProfileOpen]);

    return (
        <Link
            to={`/profile/account/${accountId}/${target || ACCOUNT_TABS.PROFILE.name}`}
            onClick={onTrackAccountProfileOpen}
            target={blank ? '_blank' : undefined}>
            <EllipsisTextHint title={accountName}>
                {accountName}
            </EllipsisTextHint>
        </Link>
    );
};
